import React from 'react';
import { connect } from "react-redux";
import checkJwt from './../../../Global/jwtChecker'  
import logout from './../../../Global/logout'
import Search from './Search'
import Table from './Table'

export class Main extends React.Component{

    state={
        loading: true,
        error: false,
        invoices: []
    }

    componentDidMount = async () => {
        document.title= "Računi"
        this.setState({
            loading: true
        })

        const unHashedJwt = await checkJwt()

        if(!unHashedJwt){
            logout()
        }

        this.setState({
            loading: false
        })
 
    }

    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }
    
    editClient(e){
        alert("Izvoz u PDF")
    }

    render(){  
        return(    
            <>              
                <main id="main_racuni" style={{height: "auto !important"}}>                     
                    <header>
                        <h1>
                            Izvještaji
                        </h1>
                    </header>
                                  
                    <Search />  

                    <div className="IzvjestajiTable">              
                        <div className="racuniTabs">
                            <Table/>
                        </div>                    
                    </div>                  
                </main>
            </>
        )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.client.userLoggedIn,
        asideToggled: state.clientSettings.asideToggled,
        jwtToken: state.client.jwtToken
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);